import TeacherLayout from "./TeacherLayout";
import { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize.min';
import {  FaSearch, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { ImCross } from "react-icons/im";

const AddResult = ({ students }) => {
    const [ programmeCode, setProgrammeCode ] =  useState('');
    const [ surname, setSurname ] = useState('');
    const [ error, setError ] = useState(null);
    const [ searchResult, setSearchResult ] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
    }

    const handleSearch = (e) => {
        e.preventDefault();

        if(surname !== '' || programmeCode !== '' ){
            setError(null);
            //check if students in db
            let student;

            if (students) {
                student = students.filter((stud) => {
                    return stud.surname === surname && stud.classCode === programmeCode
                });
                
                if(student.length === 0 ){
                    setError('No matching results...');
                } else {
                    setError(null);
                    let data = student[0];
                    setSearchResult(data);
                }
                //console.log(student);
            }

        } else {
            setError('Please select a class and input a surname.');
        }

            
    }

    useEffect(() => {
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {
            dropdownOptions: {
                coverTrigger: false, 
                hover: true
            }
        });
    }, []);

    
    
    return ( 
        <TeacherLayout>
            <div className="pt-4">
                <div className="container">
                    <form className="row mt-5" onSubmit={handleSubmit}>
                        <div className="col s12 m2 l5">
                            <div className="input-field">
                                <select onChange={(e) => setProgrammeCode(e.target.value)} value={programmeCode} >
                                    <option value="" disabled>Select</option>
                                    <option value="CV082021 NC1">CV082021 NC1</option>
                                    <option value="CV082021 NC2">CV082021 NC2</option>
                                    <option value="CV012022 NC3">CV012022 NC3</option>
                                    <option value="CV012022 NC4">CV012022 NC4</option>
                                    <option value="CV012022 NC5">CV012022 NC5</option>
                                    <option value="QS082021 NC1">QS082021 NC1</option>
                                    <option value="QS012022 NC2">QS012022 NC2</option>
                                    <option value="QS012022 NC3">QS012022 NC3</option>
                                    <option value="ARC082021 NC1">ARC082021 NC1</option>
                                    <option value="ARC012022 NC2">ARC012022 NC2</option>
                                    <option value="ARC012022 NC3">ARC012022 NC3</option>
                                    <option value="VAL012022 NC1">VAL012022 NC1</option>
                                    <option value="VAL012022 NC2">VAL012022 NC2</option>
                                    <option value="IRR012022 NC1">IRR012022 NC1</option>
                                    <option value="SG012022 NC1">SG012022 NC1</option>
                                    <option value="SG012022 NC2">SG012022 NC2</option>
                                    <option value="UB012022 NC1">UB012022 NC1</option>
                                    <option value="UB012022 NC2">UB012022 NC2</option>
                                    <option value="IT012022 NC1">IT012022 NC1</option>
                                    <option value="IT012022 NC2">IT012022 NC2</option>
                                    <option value="PS012022 NC1">PS012022 NC1</option>
                                    <option value="PS012022 NC2">PS012022 NC2</option>
                                    <option value="TM012022 NC1">TM012022 NC1</option>
                                    <option value="TM012022 NC2">TM012022 NC2</option>
                                    <option value="RM012022 NC1">RM012022 NC1</option>
                                    <option value="RM012022 NC2">RM012022 NC2</option>
                                    <option value="SS012022 NC1">SS012022 NC1</option>
                                    <option value="SS012022 NC2">SS012022 NC2</option>
                                    <option value="MM012022 NC1">MM012022 NC1</option>
                                    <option value="MM012022 NC2">MM012022 NC2</option>
                                    <option value="HR012022 NC1">HR012022 NC1</option>
                                    <option value="HR012022 NC2">HR012022 NC2</option>
                                    <option value="ACC012022 NC1">ACC012022 NC1</option>
                                    <option value="ACC012022 NC2">ACC012022 NC2</option>
                                </select>
                                <label>Select Class: </label>
                            </div>
                        </div>
                        <div className="col s12 m4 l5">
                            <div className="input-field">
                                <input id="last_name" type="text" onChange={(e) => setSurname(e.target.value)} value={surname} required />
                                <label htmlFor="last_name" className="active">Surname:</label>
                            </div>
                        </div>
                        <div className="control">
                            <button 
                                className="button is-success mt-3"
                                onClick={handleSearch}
                            >
                                <span className="icon">
                                    <FaSearch color="white"/>
                                </span>
                                <span className="white-text">Search Student</span>
                            </button>
                        </div>
                        {
                            error && <p className="red-text text-darken-3 mt-4">{ error }</p>
                        }
                    </form>
                   
                    <div className="mt-5">
                        <p className="block grey-text text-darken-2">Search Result:</p>
                        {
                            searchResult && (
                                <table className="mt-4">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Course</th>
                                            <th>Term 1</th>
                                            <th>Term 2</th>
                                            <th>Term 3</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>             
                                            <tr>
                                                <td>{searchResult.forenames} {searchResult.surname}</td>  
                                                <td>{searchResult.programme}</td>
                                                {
                                                    searchResult.currentResultsTerm === 'Term One Result' && (
                                                        <>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                            <td><ImCross size="1.1rem" fill="#af0e19"/></td>
                                                            <td><ImCross size="1.1rem" fill="#af0e19"/></td>
                                                        </>
                                                    )
                                                }
                                                {
                                                    searchResult.currentResultsTerm === 'Term Two Result' && (
                                                        <>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                            <td><ImCross size="1.1rem" fill="#af0e19"/></td>
                                                        </>
                                                    )
                                                }
                                                {
                                                    searchResult.currentResultsTerm === 'Term Three Result' && (
                                                        <>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                            <td><FaCheckCircle size="1.1rem" fill="#48c78e"/></td>
                                                        </>
                                                    )
                                                }
                                                
                                                
                                                <td><Link to={`/add-result/${searchResult.id}`} className="button is-success is-small">Add Result</Link></td>
                                            </tr>
                                    </tbody>
                                </table>

                            )
                        }                        
                    </div>
                </div>
            </div>
        </TeacherLayout>
     );
}

const mapStateToProps = (state) => {
    //console.log(state);
    return {
        students: state.firestore.ordered.students
    };
};
 
export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "students", 
            },
    ])
)(AddResult);